import axios from 'axios'
import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'
import { castAttributesForCamelCase } from '../../../modules/string_converter'
import { useFlash } from 'src/biz_spa/composables'

export type ReadStoreDocomoApiParams = {
  companyUuid: string
  storeUuid: string
}

type StoreDocomo = {
  docomoStoreId: string | null,
}

export const useCompaniesStoreDocomo = defineStore('companiesStoreDocomo', () => {
  const { updateFlash } = useFlash()
  const storeDocomo = ref<StoreDocomo>({
    docomoStoreId: null
  })
  const isLoading = ref<boolean>(false)

  // 詳細取得 API
  const readStoreDocomo = async ({
    companyUuid, storeUuid,
  }: ReadStoreDocomoApiParams) => {
    if (isLoading.value) return

    isLoading.value = true
    return axios
      .get(`/api/companies/${companyUuid}/stores/${storeUuid}/docomo`)
      .then(res => {
        storeDocomo.value = castAttributesForCamelCase(res.data.data) as StoreDocomo
      })
      .catch(err => {
        updateFlash({ type: 'alert', message: err.response.data.errors[0].detail })
        console.error(err)
      })
      .finally(() => {
        isLoading.value = false
      })
  }

  return {
    storeDocomo,
    isLoading: readonly(isLoading),
    readStoreDocomo,
  }
})
